import React from "react";
import propTypes from 'prop-types';
import classNames from "classnames";

export function Loader(props) {
    const { theme } = props;

    const block = 'c-loader';
    return (
        <div className={block}>
            <div className={classNames({
                [`${block}__spinner`]: true,
                [`lbx-theme-${theme}`]: theme,
                'apply-loader-theme': theme 
            })}></div>
        </div>
    )
}

Loader.defaultProps = {
    theme: 'lbx'
};
  
Loader.propTypes = {
    theme:propTypes.string
};